import { Routes } from '@angular/router';

import { EmployeeInformationAndDriverLicensePage } from './pages/employee-information-and-driver-license-page/employee-information-and-driver-license-page';

import { ErrorPage } from './pages/error-page/error-page';
import { HomePage } from './pages/home-page/home-page';

import { roleGuard } from './services/role-guard';

export const routes: Routes = [
  {
    path: 'consent-administration',
    canMatch: [roleGuard],
    data: {
      allowedRoles: ['CCSP_Admin', 'CCSP_Specialist'],
      checkType: 'any',
    },
    loadComponent: () =>
      import(
        './pages/consent-administration-page/consent-administration-page'
      ).then((page) => {
        return page.ConsentAdministrationPage;
      }),
  },
  {
    path: 'employee-details',
    canMatch: [roleGuard],
    data: {
      allowedRoles: ['CCSP_Admin', 'CCSP_Specialist'],
      checkType: 'any',
    },
    loadComponent: () =>
      import('./pages/employee-list-page/employee-list-page').then((page) => {
        return page.EmployeeListPage;
      }),
  },
  {
    path: 'country-state-code-maintenance',
    canMatch: [roleGuard],
    data: {
      allowedRoles: ['CCSP_Admin'],
      checkType: 'any',
    },
    loadComponent: () =>
      import(
        './pages/country-state-code-maintenance-page/country-state-code-maintenance-page'
      ).then((page) => {
        return page.CountryStateCodeMaintenancePage;
      }),
  },
  {
    path: 'employee-information-and-driver-license',
    component: EmployeeInformationAndDriverLicensePage,
  },
  // {
  //   path: 'model-code-maintenance',
  //   canMatch: [roleGuard],
  //   data: {
  //     allowedRoles: ['CCSP_Admin'],
  //     checkType: 'any',
  //   },
  //   loadComponent: () =>
  //     import(
  //       './pages/model-code-maintenance-page/model-code-maintenance-page'
  //     ).then((page) => {
  //       return page.ModelCodeMaintenancePage;
  //     }),
  // },
  {
    path: 'parameter-maintenance',
    canMatch: [roleGuard],
    data: {
      allowedRoles: ['CCSP_Admin'],
      checkType: 'any',
    },
    loadComponent: () =>
      import(
        './pages/parameter-maintenance-page/parameter-maintenance-page'
      ).then((page) => {
        return page.ParameterMaintenancePage;
      }),
  },
  {
    path: 'relationship-maintenance',
    canMatch: [roleGuard],
    data: {
      allowedRoles: ['CCSP_Admin'],
      checkType: 'any',
    },
    loadComponent: () =>
      import(
        './pages/relationship-maintenance-page/relationship-maintenance-page'
      ).then((page) => {
        return page.RelationshipMaintenancePage;
      }),
  },
  {
    path: 'mvr-score',
    data: {
      checkType: 'any',
    },
    loadComponent: () =>
      import('./pages/mvr-score-page/mvr-score-page').then((page) => {
        return page.MvrScorePage;
      }),
  },

  // {
  //   path: 'vehicle-history',
  //   loadComponent: () =>
  //     import('./pages/vehicle-history-page/vehicle-history-page').then(
  //       (page) => {
  //         return page.VehicleHistoryPage;
  //       }
  //     ),
  // },

  // {
  //   path: 'vehicle-requests',
  //   canMatch: [roleGuard],
  //   data: {
  //     allowedRoles: ['VA_Specialist'],
  //     checkType: 'any',
  //   },
  //   loadComponent: () =>
  //     import('./pages/vehicle-requests-page/vehicle-requests-page').then(
  //       (page) => {
  //         return page.VehicleRequestsPage;
  //       }
  //     ),
  // },

  // {
  //   path: 'my-profile',
  //   loadComponent: () =>
  //     import('./pages/user-profile-page/user-profile-page').then((page) => {
  //       return page.UserProfilePage;
  //     }),
  // },

  { path: 'error', component: ErrorPage },
  { path: 'home', component: HomePage },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
